export class FieldMapping {
    constructor(
        public SourceObjectType: number,
        public DestinationObjectType: number,
        public SourceFieldId: string,
        public DestinationFieldId: string,
        public CopyToTraget: boolean,
        public CopyToChild: boolean,
        public UpdateToChild: boolean,
        public UpdateToParent: boolean,
        public DateRule: string,
        public UpdateToLinkedObject: boolean,
        public PublicationChannelType: string
    ) { }
}
